import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import download from 'downloadjs';

/**
 * The blank forms THIS competition's discipline has — the backend decides
 * (BlankFormRegistry), so the Reports tab never works out for itself which
 * forms an MSAC or an FSKA competition gets.
 *
 * Resolves the list; on failure the error is reported and the list is empty.
 */
export const fetchCompetitionBlankForms = competition => dispatch =>
    axios(apiRequestOptions(apiPath.REPORTS.COMPETITION_BLANKS, null, { params: { competition } }))
        .then(transformHttpResponse)
        .then(response => response.data || [])
        .catch(error => transformHttpResponse(error.response))
        .catch(error => {
            dispatch(errorRequestHandler(error));
            return [];
        });

/** One blank form as a PDF download, in one of the sizes it comes in. */
export const fetchCompetitionBlankForm = (competition, code, size) => dispatch =>
    axios(apiRequestOptions(apiPath.REPORTS.COMPETITION_BLANK, { size }, {
        params: { competition, code },
        isBlob: true,
    }))
        .then(transformHttpResponse)
        .then(response => {
            const content = response.headers['content-type'];
            const contentDisposition = response.headers['content-disposition'] || '';
            const filenameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/);
            download(response.data, filenameMatch ? filenameMatch[1] : 'blank.pdf', content);
        })
        .catch(error => transformHttpResponse(error.response))
        .catch(error => {
            dispatch(errorRequestHandler(error));
        });
